import { ValoresContasMes } from "../../../../comercial/domain/models/valores_contas_mes";
import { IGetValoresContasMesUseCase } from "../../../presentation/useCases/read/get_valores_contas_mes_use_case";
import { IFinanceiroRepository } from "../../repositories/financeiro_repositories";

/**
 * GetValoresContasMesUseCase
 */

export class GetValoresContasMesUseCase implements IGetValoresContasMesUseCase {
  constructor(private readonly repository: IFinanceiroRepository) { }
  async execute(
    dataDe: Date | null,
    dataAte: Date | null,
    tipo: string
  ): Promise<ValoresContasMes> {
    return this.repository.getValoresContasMes(dataDe, dataAte, tipo);
  }

}
